import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Container, Col, Row, SmallText, Label } from '../';

const CategoryIcon = styled.div`
    height: 68px;	
    width: 68px;	
    padding: 15px;
    background-image: url(${props => props.src});
    background-color: #FFFFFF;
    background-position: center;
    background-repeat: no-repeat;
    display: block;
    margin: 3px auto;
    cursor: pointer;
    border: 1px solid #ECECEC;	
    border-radius: 100%;
}
`;

const CategoryCol = Col.extend`
  text-align: 'center';
  margin: 7.5px 0;
`;
const CategoryAnchor = SmallText.extend`
  display: block;
  text-align: center;
  text-decoration: none;
  color: #434447;
  margin-bottom: 0;
  &:hover {
    text-decoration: underline;
  }
`.withComponent('a');

const Category = ({
  src = 'https://material.io/guidelines/static/spec/images/callouts/default.svg',
  href,
  children,
  xs = 4,
  sm = 2
}) => (
  <CategoryCol xs={xs} sm={sm} md={2}>
    <CategoryAnchor href={href}>
      <CategoryIcon src={src} />
      {children}
    </CategoryAnchor>
  </CategoryCol>
);

Category.propTypes = {
  src: PropTypes.string,
  href: PropTypes.string,
  children: PropTypes.node,
  xs: PropTypes.number,
  sm: PropTypes.number
};

const FindMoreCol = Col.extend`
  border-top: 1px solid #eee;
  padding: 10px 15px;
  text-decoration: underline;
  text-align: 'center';
`;

const TitleCol = Col.extend`
  padding: 15px 20px !important;
  ${Label} {
    color: #555659;
  }
  @media (max-width: ${props => props.theme.breakpoints.sm}rem) {
    border-bottom: 1px solid #eee;
  }
`;
const FindMore = () => (
  <FindMoreCol xs={12}>
    <CategoryAnchor href="/find">View More</CategoryAnchor>
  </FindMoreCol>
);

const PopularCategories = () => (
  <Container fluid style={{ background: '#fff' }}>
    <Row gutter={0}>
      <TitleCol xs={12}>
        <Label>Popular Categories</Label>
      </TitleCol>
      <Category
        src={require('./icons/electricians.svg')}
        href="/find/electricians/get_quotes_simple"
      >
        Electricians
      </Category>
      <Category src={require('./icons/plumber.svg')} href="/find/plumbers/get_quotes_simple">
        Plumbers
      </Category>
      <Category src={require('./icons/handyman.svg')} href="/find/handyman/get_quotes_simple">
        Handymen
      </Category>
      <Category src={require('./icons/builders.svg')} href="/find/builders/get_quotes_simple">
        Builders
      </Category>
      <Category src={require('./icons/painters.svg')} href="/find/painters/get_quotes_simple">
        Painters
      </Category>
      <Category
        src={require('./icons/cleaning.svg')}
        href="/find/cleaning_services/get_quotes_simple"
      >
        Cleaners
      </Category>
      <FindMore />
    </Row>
  </Container>
);

export default PopularCategories;
